import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export const StyledCode = styled.pre`
  color: ${themeGet('color.colorWhite')};
  background: ${themeGet('color.colorBlue100')};
  padding: ${themeGet('scale.scaleDown03')};
  border-radius: ${themeGet('scale.scaleDown04')};
  display: block;
  overflow: hidden;
  font-size: ${themeGet('scale.scaleDown01')};
  font-family: Menlo, 'SFMono-Regular', Consolas, 'Liberation Mono', Courier,
    monospace;

  > code:first-of-type {
    color: ${themeGet('color.colorGrayBlue60')};
    background: ${themeGet('color.colorGrayBlue90')};
    padding: ${themeGet('scale.scaleDown03')} !important;
    text-align: center;
    min-width: 2em;
    border-radius: 3px;
    margin-right: ${themeGet('scale.scaleDown02')};
  }

  > code:last-of-type {
    font-weight: bold;
    padding: ${themeGet('scale.scaleDown03')} 0;
    display: block;
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: ${themeGet('color.colorGrayBlue60')} transparent;
    ::-webkit-scrollbar {
      height: ${themeGet('scale.scaleDown03')};
    }
    ::-webkit-scrollbar-track {
      background: transparent;
    }
    ::-webkit-scrollbar-thumb {
      background: ${themeGet('color.colorGrayBlue60')};
      border-radius: ${themeGet('scale.scaleDown04')};
    }
  }

  .hljs-comment {
    color: ${themeGet('color.colorGrayBlue60')};
  }

  .hljs-string {
    color: ${themeGet('color.colorYellow30')};
  }

  .hljs-keyword {
    color: ${themeGet('color.colorTurquoise40')};
  }

  .hljs-built_in {
    color: ${themeGet('color.colorRed30')};
  }

  .hljs-title {
    color: ${themeGet('color.colorGreen30')};
  }

  .hljs-symbol,
  .hljs-attr {
    color: ${themeGet('color.colorOrange30')};
  }
`;

export default StyledCode;
